import React, { Children, createContext, useContext, useState } from "react"
import { Patient } from "../pages/EditPatient";

interface PatientContext extends Patient {
  id: string;
};

export interface userContextProps {
  setPatientContext: any;
  patientContext: PatientContext | undefined;
}

const userContext = createContext<userContextProps>({} as any);

export const UserProvider: React.FC = ({ children }) => {
  const [patientContext, setPatientContext] = useState<PatientContext>();
  return (
    <userContext.Provider value={{patientContext, setPatientContext}}>
      {children}
    </userContext.Provider>
  )
}

export function useUser() {
  const context = useContext(userContext);

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
}